export enum CustomerPagePath {
  Root = '/',
  Home = '/home',
  ProductList = '/productList',
  ProductDetail = '/productDetail',
  OrderStatus = '/orderStatus',
  Notice = '/notice',
  DocumentGrant = '/documentGrant',
  AccountInfo = '/accountInfo',
  Contact = '/contact',
  Login = '/login',
  SendSMS = '/sendSMS',
  ReissuePassword = '/reissuePassword',
  ChangePassword = '/changePassword',
  Maintenance = '/maintenance',

  //口座開設
  AddvanceQuestion = '/advanceQuestion',
  ConsentSecurities = '/consentSecurities',
  ConsentTrust = '/consentTrust',
  CustomerInfo = '/customerInfo',
  DepositAccount = '/depositAccount',
  Employment = '/employment',
  InvestmentInfo = '/investmentInfo',
  RequestConfirm = '/requestConfirm',
  RequestComplete = '/requestComplete',
}

//　ログインが必要なパス 画面が増えた場合は追加必須
const needLoginPathList = [
  CustomerPagePath.Home,
  CustomerPagePath.ProductList,
  CustomerPagePath.ProductDetail,
  CustomerPagePath.OrderStatus,
  CustomerPagePath.Notice,
  CustomerPagePath.DocumentGrant,
  CustomerPagePath.AccountInfo,
  CustomerPagePath.Contact,
];

export const checkNeedLoginPath = (pathName: string) => {
  return needLoginPathList.some((x) => x === pathName);
};
